// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__clCyw","modalContent":"styles_modalContent__Bw3UX","active":"styles_active__oL9Ay","hidden":"styles_hidden__0yi3G"};